import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const GrnCreateModal = ({ show, onHide, onConfirm, selectedPO }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create GRN</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-0 text-black">
          Are you sure to create GRN of PO
          <span className="fw-semibold"> #{selectedPO?.po_code}?</span>
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="falcon-danger" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Create
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GrnCreateModal;
